import { PropsBase } from '../model/props-base';

export interface ArtistNameProps extends PropsBase {
    pseudonym?: string;
    firstName?: string;
    lastName?: string;
}

export const ArtistName = ((props: ArtistNameProps) => {
    const { pseudonym, firstName: first, lastName: last } = props;

    return (
        <div style={props.style} className={`text-uppercase ${props.className}`}>
            {(pseudonym) && (<span className="text-avenir-ul">{pseudonym}</span>)}
            {!(pseudonym) && (
                <div>
                    <span className="text-avenir-ul">{first}</span>
                    <span className="text-avenir-re">{last}</span>
                </div>
            )}
        </div>
    );
});